<template>
  <div>

    <vs-row vs-w="12" class="mb-2">
      <vs-col
        vs-type="flex"
        vs-justify="left"
        vs-align="left"
        vs-lg="4"
        vs-sm="4"
        vs-xs="12"
      >
     
     
      </vs-col>
      <vs-col
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-lg="4"
        vs-sm="4"
        vs-xs="12"
      >
      <h5>
        {{
          campaignDescription ? 'Campaign : ' + campaignDescription.campaign_name + ' ' + campaignDescription.campaign_code : null
        }}
      </h5>
      </vs-col>
      <vs-col
        vs-type="flex"
        vs-justify="right"
        vs-align="right"
        vs-lg="4"
        vs-sm="4"
        vs-xs="12"
      >

      </vs-col>
    </vs-row>
   

    <div>
      <div class="vx-col w-full">
        <vs-row
        :class="{
          'blur-content':
            AuditTrialPopupActive || AuditTrialWithDialPopupActive
        }"
        class="pb-1"
      >
        <vx-card>
          <vs-row vs-w="12" class="mb-2">
            <vs-col
              vs-type="flex"
              vs-justify="left"
              vs-align="left"
              vs-lg="2"
              vs-sm="2"
              vs-xs="12"
            >
         
           
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="8"
              vs-sm="8"
              vs-xs="12"
            >

            <strong> <span class=" p-2">Start: </span></strong>
            <flat-pickr
              :config="configDatePicker"
              placeholder="Choose start time"
              name="start_time"
              v-model="filter.start_date"
            />
  
            <strong><span class="ml-5 p-2">End: </span></strong>
            <flat-pickr
              :config="configDatePicker"
              placeholder="Choose end time"
              name="end_time"
              v-model="filter.end_date"
            />


           
            <!-- <vs-button class="ml-5" @click="resetAll" color="danger"
            >Reset</vs-button
          > -->
          <vs-button  class="ml-5" @click="filterStartEndDate" color="primary"
            >Submit</vs-button
          >
             
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="right"
              vs-align="right"
              vs-lg="2"
              vs-sm="2"
              vs-xs="12"
            >
      
            </vs-col>
          </vs-row>
         
        </vx-card>
      </vs-row>

        <vs-row
          :class="{
            'blur-content':
              AuditTrialPopupActive || AuditTrialWithDialPopupActive
          }"
          vs-w="12"
          class="mt-2"
        >
          <vs-col vs-type="flex" vs-lg="3" vs-sm="12" vs-xs="12">
            <vx-card>

              <vs-row vs-w="12" class="mb-2">
                <vs-col
                  vs-type="flex"
                  vs-justify="left"
                  vs-align="left"
                  vs-lg="2"
                  vs-sm="2"
                  vs-xs="12"
                >
                <h5> Accounts </h5>

                <vs-icon class="ml-5 pointer"
                @click="refreshSDAccount"
                size="small"
                color="dark"
                icon="refresh"
              ></vs-icon>
               
                </vs-col>
                <vs-col
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="8"
                  vs-sm="8"
                  vs-xs="12"
                >
    
            
                 
                </vs-col>
                <vs-col
                  vs-type="flex"
                  vs-justify="right"
                  vs-align="right"
                  vs-lg="2"
                  vs-sm="2"
                  vs-xs="12"
                >
          
                </vs-col>
              </vs-row>




              <!-- <vs-icon icon="refresh" size="small" 
              ></vs-icon> -->
              

              <div class="agrid-scroll">
               
            
                <SDAccountDataGrid
                  :context="'SDQCAccount'"
                  @showStatusPopUp="showStatusPopUp"
                  @showTagPopUp="showAccountTagPopUp"
                  ref="SDQCAccount"
                  :columnDefs="accountColumnDefs"
                  :rowData="accountRecords"
                  @showContactsWithAccountID="showContactsWithAccountID"
                  :rowSelection="'single'"
                >
                  <template v-slot:refresh-button>
                   
                  </template>

                
                </SDAccountDataGrid>
              </div>
              <div class="p-5"></div>
             

            </vx-card>
          </vs-col>
          <vs-col vs-type="flex" vs-lg="7" vs-sm="12" vs-xs="12">
            <vx-card>


              <vs-row vs-w="12" class="mb-2">
                <vs-col
                  vs-type="flex"
                  vs-justify="left"
                  vs-align="left"
                  vs-lg="2"
                  vs-sm="2"
                  vs-xs="12"
                >
                <h5> Contacts </h5>

                <vs-icon class="ml-5 pointer" 
                @click="refreshSDContact"
                size="small"
                color="dark"
                icon="refresh"
              ></vs-icon>
               
                </vs-col>
                <vs-col
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="8"
                  vs-sm="8"
                  vs-xs="12"
                >
    
            
                 
                </vs-col>
                <vs-col
                  vs-type="flex"
                  vs-justify="right"
                  vs-align="right"
                  vs-lg="2"
                  vs-sm="2"
                  vs-xs="12"
                >
          
                </vs-col>
              </vs-row>


              <div class="agrid-scroll">
             

                <SDContactDataGrid
                :context="'SDQCContactFilterGradeChange'"
                @showStatusPopUp="showStatusPopUp"
                @showTagPopUp="showContactTagPopUp"
                ref="SDQCContactFilterGradeChange"
                :columnDefs="contactsColumnDefs"
                :rowData="contactRecords"
                @showContactsWithAccountID="showContactsWithAccountID"
                :rowSelection="'single'"
                @showSalesDeveloperAuditTrial="showSalesDeveloperAuditTrial"
                @onSDQCAccountFilterModified="onSDQCAccountFilterModified"
                @showContactsFieldsWithContactID="showContactsFieldsWithContactID"

              >
              

              
              </SDContactDataGrid>

                
            
              </div>


            </vx-card>
          </vs-col>
          <vs-col vs-type="flex" vs-lg="2" vs-sm="12" vs-xs="12">
            <vx-card title="Notes">
         

              <p v-if="accountNotes">
                {{ accountNotes.notes }}
              </p>
              <p v-if="contactNotes">
                {{ contactNotes.summary }}
              </p>

              <vs-divider />
              <div class="audit_trial_style">
                <h4 class="mb-5">Audit Trial - Attempts: {{ dial_counts }}</h4>

                <!-- {{contactsAuditTrials}} -->
                <template v-for="cat in contactsAuditTrials">
                  <div class="mb-2">
                    <h6 class="mb-1">Action Type</h6>
                    <p>
                      {{ cat.action_type }}
                    </p>
                  </div>

                  <div class="mb-2">
                    <h6 class="mb-1">Outcome</h6>
                    <p>
                      {{ cat.outcome }}
                    </p>
                  </div>

                  <div class="mb-2">
                    <h6 class="mb-1">Sales Developer</h6>
                    <p>
                      {{ cat.sales_developer }}
                    </p>
                  </div>

                  <div class="mb-2">
                    <h6 class="mb-1">Date/Time</h6>
                    <p>
                      {{ cat.date_time }}
                    </p>
                  </div>

                  <div class="mb-2">
                    <h6 class="mb-1">Notes</h6>
                    <p>
                      {{ cat.notes }}
                    </p>
                  </div>

                  <vs-divider class="p-2" />
                </template>
              </div>
            </vx-card>
          </vs-col>
        </vs-row>
      
      </div>
    </div>
  </div>
</template>
<script>



import moduleAccountsManagement from '@/store/accounts-management/moduleAccountsManagement.js'
import defineAbilitiesFor from '@/config/abilities'
import moduleCampaignsManagement from '@/store/campaign-management/moduleCampaignManagement.js'
import vSelect from 'vue-select'
import _ from 'lodash'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import SDContactDataGrid from "@/components/aggrid/SDContactAggrid.vue";
import SDAccountDataGrid from "@/components/aggrid/SDAccountAggrid.vue";
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import AccountAutocomplete from '@/components/autocomplete/AccountsAutocomplete.vue'
import moduleAuditTrialManagement from '@/store/audit-trial-management/moduleAuditTrialManagement.js'
import moduleElomarkUserManagement from '@/store/elomark-user-management/moduleElomarkUserManagement.js'
import moment from 'moment'


var filterDateParams = {
  comparator: (filterLocalDateAtMidnight, cellValue) => {
    cellValue = moment(cellValue).format('DD/MM/YYYY')

    var dateAsString = cellValue;
    if (dateAsString == null) return -1;
    var dateParts = dateAsString.split('/');
    var cellDate = new Date(
      Number(dateParts[2]),
      Number(dateParts[1]) - 1,
      Number(dateParts[0])
    );

    if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
      return 0;
    }

    if (cellDate < filterLocalDateAtMidnight) {
      return -1;
    }

    if (cellDate > filterLocalDateAtMidnight) {
      return 1;
    }
    return 0;
  },
  inRangeFloatingFilterDateFormat: 'Do MMM YYYY',
  buttons: ["apply", "reset"],
  maxNumConditions: 4
};



import '@/assets/css/drag.css'
export default {
  data: () => ({

    configDatePicker: {
        enableTime: true,
        dateFormat: "Y-m-d H:i",
        time_24hr: true
      },
    filter: {
        start_date: moment(new Date()).format('YYYY-MM-DD'),
      end_date: moment(new Date()).endOf('day').format('YYYY-MM-DD HH:mm')
    },


    all_seniorities : [],
      all_roles : [],
      all_sub_roles : [],
    all_currency_codes : [],
      all_verticals : [],
      all_sic_codes : [],
      all_countries : [],
    all_field_datas : {},
    all_contact_field_datas : {},
    acc_col : [],
    last_opportunity : null,
    showOpportunityExistsPopup : false,
    dial_counts: 0,
    viewing_as_full_name: null,
    sales_developer_id: null,
    email_validate_status: null,
    componentKey: 0,
    please_choose_account_tag: null,
    please_choose_contact_tag: null,
    selected_contact_tag: [],
    selected_account_tag: [],
    authorized: true,
    phoneTypes: [],
    selected_sd_account_id: null,
    selected_contact_status: null,
    selected_contact_table_id: null,
    selected_account_status: null,
    selected_account_table_id: null,
    selected_view_for_sd: null,
    sd_view_options: [],
    showHideSaveViewPopUp: false,
    please_choose_save_view_name: null,
    save_view_name: null,
    save_view_description: null,
    selected_status_notes: null,
    showAccountTagFilterOption: false,
    showContactTagFilterOption: false,
    selected_account_contact_status_data: null,
    selected_status: null,
    all_sd_status: [],
    showHideStatusPopUp: false,
    selected_filter_account_tag: [],
    selected_filter_contact_tag: [],
    all_contact_tags: [],
    accountNotes: null,
    contactNotes: null,
    selected_tag: [],
    please_choose_status: null,
    please_choose_status_notes: null,
    please_choose_tag: null,
    all_account_tags: [],
    showTagAccountPopUp: false,
    showTagContactPopUp: false,
    grade_description: [],
    selected_grade_steps: [],
    step_by_step_grade_steps: [],
    opportunity_fields: [],
    grades: {
      grade: null
    },
    grade_options: [],
    showGradePopUp: false,
    showGradeStepsPopUp: false,
    showOpportunitiesPopUp: false,
    selected_campaign: null,
    contactsAuditTrials: [],
    auditTrialWithDial: false,
    auditTrialSelectedContact: null,
    action_types: [],
    outcomes: [],
    audit_trial: {
      date_time: moment(new Date()).format('YYYY-MM-DD hh:mm:ss'),
      outcome: null,
      notes: null,
      action_type: null,
      campaign_id: null,
      sales_developer_id: null,
      account_id: null,
      contact_id: null
    },
    audit_trial_with_dial: {
      action_type: null,
      date_time: moment(new Date()).format('YYYY-MM-DD hh:mm:ss'),
      outcome: null,
      notes: null
    },
    schedule_a_next_action: {
      sales_developer_id: null,
      subject: null,
      start_date_time: moment(new Date()).format('YYYY-MM-DD hh:mm:ss'),
      end_date_time: moment(new Date()).format('YYYY-MM-DD hh:mm:ss'),
      campaign_id: null,
      notes: null,
      selected_account_contact: null
    },
    AuditTrialWithDialPopupActive: false,
    AuditTrialPopupActive: false,
    selectedDialAccountContact: null,
    showEditNumbers: false,
    listofNumbers: [],
    showDialTitle: null,
    user_id: null,
    showSocial_mediaExtraField: false,
    showEmailExtraField: false,
    showMobileExtraField: false,
    showDdiExtraField: false,
    showLinkedExtraField: false,
    showPhoneExtraField: false,
    showWebsiteExtraField: false,

    selectedEditContactId: null,
    website_counter: 0,

    websites: [
      {
        counter: 0,
        url: null
      }
    ],
    linkedin_counter: 0,

    linkedins: [
      {
        counter: 0,
        url: null
      }
    ],
    email_counter: 0,

    emails: [
      {
        counter: 0,
        email: null,
        is_primary: null
      }
    ],
    social_media_counter: 0,

    social_medias: [
      {
        counter: 0,
        social_media: '',
        summary: null,
        is_primary: null
      }
    ],
    mobile_counter: 0,

    mobiles: [
      {
        counter: 0,
        mobile: '',
        mobile_phone_code: null,
        is_primary: null
      }
    ],
    ddi_counter: 0,

    ddis: [
      {
        counter: 0,
        ddi: null,
        ddi_phone_code: null,
        is_primary: null
      }
    ],
    phone_counter: 0,

    phones: [
      {
        counter: 0,
        phone_no: '',
        phone_code: ''
      }
    ],
    checkedFields: {},
    opportunitiesCheckedFields: {},

    configDateTimePicker: {
      enableTime: false,
      dateFormat: 'Y-m-d'
    },
    configDateAndTimePicker: {
      enableTime: true,
      dateFormat: "Y-m-d H:i:s",
      enableSeconds : true
    },
    componentKey: 0,
    editSDAccountPopUp: false,
    editSDContactPopUp: false,

    dialPopupActive: false,
    abilities: null,
    accountSDQCAccountFields: [],
    contactSDQCContactFields: [],
    accountColumnDefs: [],
    contactsColumnDefs: [],
    campaignFieldsDataSource: {},
    campaignFieldsRecords: [],
    campaignsRecords: [],
    selected_account_id: null,
    contactColumnDefs: [],
    campaignName: null,
    campaignDescription: [],
    accountRecords: null,
    contactRecords: null,
    campaignId: null,
    abilities: null,
    selected_contact_id: null,
    contactDataSource: {},
    getSDAccountSelectedFieldRecords: [],
    getSDContactSelectedFieldRecords: [],
    contactParamsRequest: {},
    editSelectedAccount: {},
    editSelectedContact: {},
    selectedEditCampaignId: null,
    selectedEditAccountId: null,
    master_field_options: null,
    client_field_options: null,
    campaign_field_options: null,
    opportunity_field_options: [],
    opportunity_field_datas: [],
    master_field_datas: {},
    client_field_datas: {},
    campaign_field_datas: {},
    contact_master_field_datas: {},
    contact_client_field_datas: {},
    contact_campaign_field_datas: {},
    core_field_datas: {},
    showHeadOfficeCountryField: true,
    showHeadOfficeEditAutocomplete: false,
    showRegisteredOfficeCountryField: true,
    showRegisteredOfficeEditAutocomplete: false,
    showRegistrationJurisdictionField: true,
    showRegistrationJurisdictionEditAutocomplete: false,
    showParentField: true,
    showParentEditAutocomplete: false,
    showVerticalField: true,
    showVerticalEditAutocomplete: false,
    showSatelliteOfficeCountryField: true,
    showSatelliteOfficeEditAutocomplete: false,
    roles: [],
    seniorities: [],
    sub_roles: [],
    primary_mobile: null,
    primary_ddi: null,
    dialAction: null,
    optionDescription: [],
    audittrial_action_type_id: null,
    audittrial_outcome_grade: null,
    audittrial_outcome_id: null,
    selected_options: [],
    showSchedulePopUp: false,
    selected_account_contact: null,
    old_master_field_datas: {},
    search: '',
    toggle: false,
    campaign_client_contacts: [],
    newCampaignClientContacts: [],
    showOpportunityPopUpFromGrade: false,
    campaign_view_settings: {
      auto_size_cell_contents: null,
      selected_contact_aggrid_node: null,
      selected_account_aggrid_node: null
    },
    lastPageAccount: 0,
    // vueDraggablePopUpOptions: {'width' : 600 , 'left': 600 , 'top' : 60, 'buttonPin' : false , zIndex: 9999999},
    vueDraggableDialPopUpOptions: {
      width: 600,
      centered: 'parent',
      buttonPin: false,
      buttonClose: false,
      zIndex: 9999999
    },
    vueDraggablePopUpOptions: {
      width: 600,
      centered: 'parent',
      buttonPin: false,
      zIndex: 9999999
    }
  }),
  components: {
    'v-select': vSelect,
    flatPickr,
    AccountAutocomplete,
    SDContactDataGrid,
    SDAccountDataGrid,
  },
  watch: {
   
  },
  methods: {
    filterStartEndDate() {
      let self = this

      self.contactsAuditTrials = []
      self.accountNotes = null
      self.dial_counts = 0


      let filter = {};
      filter.user_role = this.user_role;
      filter.user_id = this.user_id;
      filter.start_date = this.filter.start_date;
      filter.end_date = this.filter.end_date;




      this.refreshSDContact()

             
      self.$refs.SDQCContactFilterGradeChange.gridApi.showLoadingOverlay();
      self.$refs.SDQCAccount.gridApi.showLoadingOverlay();


    this.getContactDataSource()
    this.getAccountDataSource()


    
     
    },
    resetAll() {
      this.filter.start_date = null;
      this.filter.end_date = null;
    },


    getSDCampaignViewSettings () {
      let self = this
      let data = {}
      data.user_id = self.user_id
      self.$store
        .dispatch('campaignsManagement/fetchAllSDCampaignViewSettings', data)
        .then(res => {
          let result = res.data
          if (result) {
            let result_data = JSON.parse(res.data)

            let newObj = {}

            result_data.forEach(function (ele) {
              newObj[ele.setting_type] = ele.status
            })

            self.campaign_view_settings = newObj

            let wrapText = false
            let autoHeight = false
            if (
              self.campaign_view_settings.auto_size_cell_contents == 'enabled'
            ) {
              wrapText = true
              autoHeight = true
            }

            self.accountSDQCAccountFields = [
              {
                flex: 1,
                headerName: 'Column',
                field: 'column',
                filter: 'agTextColumnFilter',
                filterParams: {
                  buttons: ['apply', 'reset'],
                  maxNumConditions: 4
                }
              },
              {
                flex: 1,
                headerName: 'Value',
                field: 'value',
                filter: 'agTextColumnFilter',
                filterParams: {
                  buttons: ['apply', 'reset'],
                  maxNumConditions: 4
                },
                wrapText: true,
                autoHeight: true,
                cellRenderer : function(params) {
                return params.value ? params.value : '';
            },
                valueGetter: (params) => {
      return params.data.value;
    },
              }
            ]

            self.contactSDQCContactFields = [
              {
                flex: 1,
                headerName: 'Column',
                field: 'column',
                filter: 'agTextColumnFilter',
                filterParams: {
                  buttons: ['apply', 'reset'],
                  maxNumConditions: 4
                }
              },
              {
                flex: 1,

                headerName: 'Value',
                field: 'value',
                filter: 'agTextColumnFilter',
                filterParams: {
                  buttons: ['apply', 'reset'],
                  maxNumConditions: 4
                },
                wrapText: true,
                autoHeight: true,


                cellRenderer : function(params) {
                return params.value ? params.value : '';
            },
                valueGetter: (params) => {
      return params.data.value;
    },
              }
            ]
          }
        })
    },
    contact_selected_role (event) {
      this.getSubRole(event.id)
    },
    getCampaignGrades (selected_campaign) {
      let self = this
      this.$store
        .dispatch('campaignsManagement/getCampaignGrades', selected_campaign)
        .then(res => {
          let result = res.data
          let grade_description = []

          self.grade_options.forEach(function (e) {
            result.forEach(function (ele) {
              if (e.grade == ele.grade) {
                grade_description.push(ele)
              }
            })
          })

          self.grade_description = grade_description
        })
        .catch(err => {
          console.log(err)

          if (err.response.status === 401) {
            self.$router.replace('/login')
          }
        })
    },
    selectResult (client_contact , column_id) {
      let self = this
      self.search = client_contact.full_name

      let dataObj = {}
      dataObj.full_name = client_contact.full_name
      dataObj.id = client_contact.uuid

      for (const property in self.opportunity_field_datas) {
        self.opportunity_field_datas[column_id].value = dataObj
      }

      // console.log("SLEEE res" , self.opportunity_field_datas)
    },

    updatePrimaryDdi (v, field_name) {
      this.core_field_datas[field_name].forEach(function (m) {
        m.is_primary = false

        if (m.ddi == v.ddi) {
          m.is_primary = true
        }
      })

      this.ddis.forEach(function (m) {
        m.is_primary = false

        if (m.ddi == v.ddi) {
          m.is_primary = true
        }
      })
    },
    updatePrimaryEmail (v, field_name) {
      this.core_field_datas[field_name].forEach(function (m) {
        m.is_primary = false

        if (m.email == v.email) {
          m.is_primary = true
        }
      })

      this.emails.forEach(function (m) {
        m.is_primary = false

        if (m.email == v.email) {
          m.is_primary = true
        }
      })
    },
    updatePrimarySocialMedia (v, field_name) {
      this.core_field_datas[field_name].forEach(function (m) {
        m.is_primary = false

        if (m.social_media == v.social_media) {
          m.is_primary = true
        }
      })

      this.social_medias.forEach(function (m) {
        m.is_primary = false

        if (m.social_media == v.social_media) {
          m.is_primary = true
        }
      })
    },
    updatePrimaryMobile (v, field_name) {
      this.core_field_datas[field_name].forEach(function (m) {
        m.is_primary = false

        if (m.mobile == v.mobile) {
          m.is_primary = true
        }
      })

      this.mobiles.forEach(function (m) {
        m.is_primary = false

        if (m.mobile == v.mobile) {
          m.is_primary = true
        }
      })
    },
    getSDViewLists () {
      let self = this
      let data = {}
      data.campaign_id = self.$route.params.campaignId
      data.sales_developer_id = self.user_id
      self.$store
        .dispatch('campaignsManagement/getSDViewLists', data)
        .then(res => {
          if (res) {
            self.sd_view_options = res.data

            self.sd_view_options.forEach(function (e) {
              if (e.is_default_view) {
                self.selected_view_for_sd = e
              }
            })
          }
        })
        .catch(err => {
          console.error(err)
        })
    },

    saveViewPopup () {
      this.showHideSaveViewPopUp = true
      // console.log("Account COLUMNSTATE" , this.$refs.SDQCAccount.gridApi.getColumnState())

      // console.log("Contact COLUMNSTATE" , this.$refs.SDQCContactFilterGradeChange.gridApi.getColumnState())
    },
    viewOpportunities () {
      this.$router.push({
        path:
          '/views/sd_campaign_view/sales_developer_opportunities/' +
          this.$route.params.campaignId +
          '/' +
          this.$route.params.campaignName +
          '/' +
          this.$route.params.sd_user_id +
          '/' +
          this.$route.params.sd_user_full_name
      })

      // this.$router.push({
      //   path: '/sales_developer_opportunities/' + this.campaignId
      // })
    },
    showAccountTagFilter () {
      this.fetchAllAccountTagsWithSalesDeveloperId()
      this.showAccountTagFilterOption = !this.showAccountTagFilterOption
    },
    showContactTagFilter () {
      this.fetchAllContactTagsWithSalesDeveloperId()
      this.showContactTagFilterOption = !this.showContactTagFilterOption
    },
   
   
  
    fetchAllAccountTagsWithSalesDeveloperId () {
      this.$store
        .dispatch(
          'TagsManagement/fetchAllTagsWithSalesDeveloperId',
          this.sales_developer_id
        )
        .then(res => {
          let result = res.data
          result = result.filter(ele => ele.type == 'account')
          this.all_account_tags = result
          console.log(this.all_account_tags)
        })
        .catch(err => {
          console.error(err)
        })
    },
    fetchAllContactTagsWithSalesDeveloperId () {
      this.$store
        .dispatch(
          'TagsManagement/fetchAllTagsWithSalesDeveloperId',
          this.sales_developer_id
        )
        .then(res => {
          let result = res.data
          result = result.filter(ele => ele.type == 'contact')
          this.all_contact_tags = result
        })
        .catch(err => {
          console.error(err)
        })
    },
    showAccountTagPopUp (data) {
      this.selected_account_tag = data.tag_ids
      this.fetchAllAccountTagsWithSalesDeveloperId()
      this.showTagAccountPopUp = true
      this.selected_account_tag_data = data
    },
    showContactTagPopUp (data) {
      this.selected_contact_tag = data.tag_ids
      this.fetchAllContactTagsWithSalesDeveloperId()
      this.showTagContactPopUp = true
      this.selected_contact_tag_data = data
    },
    fetchAllSDStatus () {
      this.$store
        .dispatch('campaignsManagement/fetchAllSDStatus')
        .then(res => {
          let result = res.data
          this.all_sd_status = result
        })
        .catch(err => {
          console.error(err)
        })
    },
    showStatusPopUp (data) {
      this.fetchAllSDStatus()
      this.showHideStatusPopUp = true
      this.selected_account_contact_status_data = data
    },
    addAccountTags () {
      this.$router.push({
        path:
          '/views/all_sd_campaign_view/assign_account_tag/' +
          this.$route.params.campaignId +
          '/' +
          this.$route.params.campaignName
      })
      // alert("add account tags")
    },
    addAccountStatus () {
      this.$router.push({
        path:
          '/views/all_sd_campaign_view/assign_account_status/' +
          this.$route.params.campaignId +
          '/' +
          this.$route.params.campaignName
      })
    },

    addContactStatus () {
      this.$router.push({
        path:
          '/views/all_sd_campaign_view/assign_contact_status/' +
          this.$route.params.campaignId +
          '/' +
          this.$route.params.campaignName
      })
    },
    addContactTags () {
      // alert(this.selected_campaign.campaign_name)
      this.$router.push({
        path:
          '/views/all_sd_campaign_view/assign_contact_tag/' +
          this.$route.params.campaignId +
          '/' +
          this.$route.params.campaignName
      })

      // alert("add contact tags")
    },
    getContactColumnData (contact_id) {
      let self = this
      let data = {}
      data.contact_id = contact_id
      data.campaign_id = self.campaignId
      self.selectedEditCampaignId = self.campaignId
      self.sales_developer_id = self.user_id
      self.selectedEditContactId = contact_id

      self.$store
        .dispatch('accountsManagement/getSDfetchContact', data)
        .then(res => {
          if (res.data) {
            self.editSelectedContact = JSON.parse(res.data)




            Object.keys(self.editSelectedContact).forEach(function (key) {







let campaign_data_options = self.editSelectedContact['campaign_data_options']

campaign_data_options.forEach(function (ele) {



  if (ele.identifier == 'none_core_field' && ele.type == 'checkbox' && ele.column_id == key  && ele.level == 'contact') {



   if (self.editSelectedContact[key] == null) {
  self.editSelectedContact[key] = []
}




if (typeof self.editSelectedContact[key] === 'string' || self.editSelectedContact[key] instanceof String) {
  


  if (self.editSelectedContact[key].startsWith('[') && self.editSelectedContact[key] != '[]') {
  
  
  
  
    self.editSelectedContact[key] = JSON.parse(self.editSelectedContact[key])
  
  
  
  
  
  
  }
  
  
  
  
  
  }








console.log(self.editSelectedContact[key])

  }



  if (ele.identifier == 'none_core_field' && ele.type == 'textarea' && ele.column_id == key  && ele.level == 'contact') {

if(self.editSelectedContact[key] == null){
  self.editSelectedContact[key] = ''
}


}

})




})

          
          }
        })
        .catch(err => {
          console.error(err)
        })

      // var array = ["id","acc_id","campaign_id","contact_campaign_id","contact_id","contact_status","contact_id", "contact_status","contact_web"];
      // this.editSelectedContact = this.deleteKeys(contact, array);
      // console.log("Contact", this.editSelectedContact);
    },
    getAccountColumnData (account_id) {
      let self = this
      let data = {}
      data.account_id = account_id
      data.campaign_id = self.campaignId
      self.selectedEditCampaignId = self.campaignId
      self.selectedEditAccountId = account_id
      self.sales_developer_id = self.user_id


      self.$store
        .dispatch('accountsManagement/getSDfetchAccount', data)
        .then(res => {
          if (res.data) {
            self.editSelectedAccount = JSON.parse(res.data)





            Object.keys(self.editSelectedAccount).forEach(function (key) {







let campaign_data_options = self.editSelectedAccount['campaign_data_options']

campaign_data_options.forEach(function (ele) {



  if (ele.identifier == 'none_core_field' && ele.type == 'checkbox' && ele.column_id == key  && ele.level == 'account') {



   if (self.editSelectedAccount[key] == null) {
  self.editSelectedAccount[key] = []
}




if (typeof self.editSelectedAccount[key] === 'string' || self.editSelectedAccount[key] instanceof String) {
  


  if (self.editSelectedAccount[key].startsWith('[') && self.editSelectedAccount[key] != '[]') {
  
  
  
  
    self.editSelectedAccount[key] = JSON.parse(self.editSelectedAccount[key])
  
  
  
  
  
  
  }
  
  
  
  
  
  }








console.log(self.editSelectedAccount[key])

  }

  if (ele.identifier == 'none_core_field' && ele.type == 'textarea' && ele.column_id == key  && ele.level == 'account') {

if(self.editSelectedAccount[key] == null){
  self.editSelectedAccount[key] = ''
}


}

})




})
            
console.log("taraju account" , self.editSelectedAccount)



          
          }
        })
        .catch(err => {
          console.error(err)
        })
    },
    submitAndShowNextStep (submittedStepId) {
      let self = this

      // self.editSDAccountPopUp = false;
      //   self.getAllOpportunityFields()
      //   self.showOpportunitiesPopUp = true;

      self.selected_grade_steps.sort((a, b) => a.order_by - b.order_by)
      if (self.selected_grade_steps.length !== 1) {
        self.selected_grade_steps = self.selected_grade_steps.filter(
          ele => ele.grade_step_id != submittedStepId
        )
        self.step_by_step_grade_steps = self.selected_grade_steps[0]
      } else {
        self.updateSDAccountFromGradeSteps()
        self.updateSDContactFromGradeSteps()
        self.editSDAccountPopUp = false
        self.getAllOpportunityFields()


        if (self.showOpportunityPopUpFromGrade) {
      
          self.getContactOpportunities()
        } else {
          self.showOpportunitiesPopUp = false
          self.selectedDialAccountContact = null
          self.auditTrialSelectedContact = null
          self.selected_account_contact = null
          // self.selectedEditContactId = null
          // self.selectedEditAccountId = null
        }


      
        self.showOpportunityPopUpFromGrade = false

        // document.getElementById("text_editor").classList.add("text_box");

        // self.getSDViewLists()
      }
    },
    getContactOpportunities(){
      let self = this
      let data = {}
      data.campaign_id = self.selectedEditCampaignId
      data.contact_id = self.selectedEditContactId
      data.account_id = self.selected_account_id
      self.$store
        .dispatch('campaignsManagement/getContactOpportunities', data)
        .then(res => {
         let response_data = JSON.parse(res.data)


           if(response_data.length > 0){






            

            let last_opp = response_data[0].opportunity




            if (typeof last_opp === 'string' || last_opp instanceof String) {


                  if (last_opp.startsWith('[') && last_opp != '[]') {
                    

                    last_opp = JSON.parse(last_opp)



                    self.last_opportunity = last_opp.toString()

                  }





                  }


            
             self.showOpportunityExistsPopup = true
           }else{
             self.showOpportunitiesPopUp = true

           }
        })
        .catch(err => {
          console.error(err)
        })

    },
    createOpportunity () {
      let self = this
      self.showGradeStepsPopUp = false
      self.getAllOpportunityFields()
      self.showOpportunitiesPopUp = true
    },
    createAnotherOpportunity () {
      let self = this
      this.showOpportunitiesPopUp = false
      self.componentKey += 1

      self.search = null

      this.showOpportunitiesPopUp = true

      let updateData = {}
      updateData.opportunity_field_datas = self.opportunity_field_datas

      updateData.campaign_id = self.selectedEditCampaignId
      updateData.contact_id = self.selectedEditContactId
      updateData.account_id = self.selected_account_id
      updateData.sales_developer_id = self.user_id
      for (const property in self.opportunitiesCheckedFields) {
        if (self.opportunitiesCheckedFields[property] == '') {
          delete self.opportunitiesCheckedFields[property]
        }
      }
      updateData.checkbox_columns = self.opportunitiesCheckedFields
      self.updateOpportunitiesToDB(updateData)

      // self.showOpportunitiesPopUp = true;
    },
    submitOpportunityValues () {
      let self = this
      let updateData = {}
      updateData.opportunity_field_datas = self.opportunity_field_datas

      updateData.campaign_id = self.selectedEditCampaignId
      updateData.contact_id = self.selectedEditContactId
      updateData.account_id = self.selected_account_id
      updateData.sales_developer_id = self.user_id
      for (const property in self.opportunitiesCheckedFields) {
        if (self.opportunitiesCheckedFields[property] == '') {
          delete self.opportunitiesCheckedFields[property]
        }
      }
      updateData.checkbox_columns = self.opportunitiesCheckedFields
      self.updateOpportunitiesToDB(updateData)

      self.showOpportunitiesPopUp = false

      self.$refs.SDQCAccount.gridApi.refreshCells({
        force: true
      })
      self.$refs.SDQCContactFilterGradeChange.gridApi.refreshCells({
        force: true
      })

      self.refreshAuditTrial()


      self.selectedDialAccountContact = null
        self.auditTrialSelectedContact = null
        self.selected_account_contact = null
        self.selectedEditContactId = null
        self.selectedEditAccountId = null

      //   self.$router.go(0);
    },
    updateOpportunitiesToDB (data) {
      let self = this
      self.$store
        .dispatch('campaignsManagement/updateSDOpportunity', data)
        .then(res => {
          self.$vs.notify({
            color: 'success',
            title: 'Opportunities',
            text: 'The opportunities was created successfully.'
          })

          self.getAllOpportunityFields()
        })
        .catch(err => {
          console.error(err)
        })
    },
    updateSDAccountFromGradeSteps () {

      



      
let updateData = {}
updateData.campaign_id = this.selectedEditCampaignId
updateData.account_id = this.selectedEditAccountId
updateData.all_field_datas = this.editSelectedAccount
updateData.account_status = this.selected_account_status
updateData.contact_status = this.selected_contact_status
updateData.account_table_id = this.selected_account_table_id
updateData.contact_table_id = this.selected_contact_table_id
updateData.sales_developer_id = this.user_id
// updateData.updated_by_admin = 'yes'


for (const property in this.checkedFields) {

if (this.checkedFields[property] == '' || this.checkedFields[property] == null) {
this.checkedFields[property] = []
}
}

updateData.checkbox_columns = this.checkedFields
let self = this

this.$store
  .dispatch('accountsManagement/updateSDQCAccount', updateData)
  .then(res => {
    this.showGradeStepsPopUp = false

    let response_data = res.data

    if (response_data.status == 'success') {
      this.$vs.notify({
        color: response_data.status,
        title: response_data.title,
        text: response_data.message
      })
    }



  
    self.$refs.SDQCContactFilterGradeChange.gridApi.clearFocusedCell()

    var get_selected_nodes = self.$refs.SDQCAccount.gridApi.getSelectedNodes()

    get_selected_nodes[0].data = JSON.parse(response_data.data)
    self.$refs.SDQCAccount.gridApi.refreshCells({
      rowNodes: [get_selected_nodes[0]],
      force: true
    })


    var focusedCell = self.$refs.SDQCAccount.gridApi.getSelectedNodes()
    let selected_row_index = focusedCell[0].rowIndex
    let page_index = Math.floor(selected_row_index / self.$refs.SDQCAccount.gridApi.paginationGetPageSize())
    self.$refs.SDQCAccount.gridApi.paginationGoToPage(page_index)


   
  })
  .catch(err => {
    console.log(err)
    if (err.response.status === 401) {
      this.$router.replace('/login')
    }
  })
},
updateSDContactFromGradeSteps () {
let updateData = {}
updateData.all_contact_field_datas = this.editSelectedContact
updateData.campaign_id = this.selectedEditCampaignId
updateData.contact_id = this.selectedEditContactId
updateData.account_status = this.selected_account_status
updateData.contact_status = this.selected_contact_status
updateData.account_table_id = this.selected_account_table_id
updateData.contact_table_id = this.selected_contact_table_id
updateData.account_id = this.selected_account_id
updateData.sales_developer_id = this.user_id
// updateData.updated_by_admin = 'yes'

let self = this

// for (const property in this.checkedFields) {

// if (this.checkedFields[property] == '' || this.checkedFields[property] == null) {
// this.checkedFields[property] = []
// }
// }

// updateData.checkbox_columns = this.checkedFields

self.$store
  .dispatch('accountsManagement/updateSDQCContact', updateData)
  .then(res => {
    // this.selectedEditCampaignId = null;
    // this.selectedEditContactId = null;

    if (!self.showOpportunityPopUpFromGrade) {
      self.showGradeStepsPopUp = false
      // self.$router.go(0);
    }

    let response_data = res.data

    if (response_data.status == 'success') {
      self.$vs.notify({
        color: response_data.status,
        title: response_data.title,
        text: response_data.message
      })
    }

    this.selected_contact_aggrid_node.data = JSON.parse(response_data.data)



    self.$refs.SDQCContactFilterGradeChange.gridApi.refreshCells({
      rowNodes: [self.selected_contact_aggrid_node],
      force: true
    })
    self.getDialCounts(
      self.selected_contact_aggrid_node.data.new_contact_id
    )

    self.refreshAuditTrial()
  })
  .catch(err => {
    console.error(err)
  })
},
    getAllGradeStepsByGradeId (grade) {
      let gradeDesc = {}
      gradeDesc.campaign_id = this.campaignId
      gradeDesc.grade_id = grade.id

      let self = this
      self.$store
        .dispatch('campaignsManagement/getAllGradeStepsByGradeId', gradeDesc)
        .then(response => {
          self.selected_grade_steps = JSON.parse(response.data)
          self.selected_grade_steps.sort((a, b) => a.order_by - b.order_by)

          if (self.selected_grade_steps) {
            self.step_by_step_grade_steps = self.selected_grade_steps[0]
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    fetchCampaignAssociatedClientContact () {
      let self = this
      this.$store
        .dispatch(
          'elomarkUsersManagement/fetchCampaignAssociatedClientContact',
          this.$route.params.campaignId
        )
        .then(res => {
          self.campaign_client_contacts =
            moduleElomarkUserManagement.state.campaign_associated_client_contact
          self.campaign_client_contacts.map(function (ele) {
            ele.full_name = ele.first_name + ' ' + ele.surname
          })
        })
        .catch(err => {
          console.log(err)
        })
    },
    getAllOpportunityFields () {
      let data = {}
      data.contact_id = this.selectedEditContactId
      data.account_id = this.selected_account_id
      data.campaign_id = this.campaignId
      data.grade_id = this.grades.grade.grade
      let self = this
      self.opportunitiesCheckedFields = {}
      self.$store
        .dispatch('campaignsManagement/getAllOpportunityFields', data)
        .then(res => {
          if (res.data) {
            let result = JSON.parse(res.data)
            self.opportunity_field_options = result[0]['options']
            self.opportunity_field_datas = result[0]['data']
            let new_opportunity_field_values = {}
            self.opportunity_field_options.forEach(function (ele) {
              Object.entries(self.opportunity_field_datas).forEach(
                ([key, value]) => {
                  if (key == ele.column_id) {
                    let json_value = null

                    try {
                      json_value = JSON.parse(value)
                    } catch (e) {
                      json_value = value
                    }

                    if (json_value != null) {
                      if (json_value.length == 1) {
                        json_value = json_value[0]
                      }

                      new_opportunity_field_values[key] = {
                        value: json_value,
                        type: ele.type,
                        options: ele.values,
                        model: key
                      }
                    } else {
                      new_opportunity_field_values[key] = {
                        value: json_value,
                        type: ele.type,
                        options: ele.values,
                        model: key
                      }
                    }
                  }
                }
              )
            })

            self.opportunity_field_datas = new_opportunity_field_values

            for (const property in self.opportunity_field_datas) {


              if (self.opportunity_field_datas[property].type == 'checkbox') {
                let new_key_name = self.opportunity_field_datas[property]
                if (!Array.isArray(new_key_name.value)) {
                  new_key_name.value = [new_key_name.value]
                }
                self.opportunitiesCheckedFields[new_key_name.model] =
                  new_key_name.value
              }


              if (self.opportunity_field_datas[property].type == 'textarea') {
               
                   if (self.opportunity_field_datas[property].value == null) {
                    self.opportunity_field_datas[property].value = ''

                   }

              }





            }
          }
        })
        .catch(err => {
          console.log(err)
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    openGradeStepsPopUp () {
      let self = this

      let data = {}
      data.campaign_id = this.campaignId
      data.selected_grade = self.grades.grade.grade
      data.sales_developer_id = self.user_id

      if (self.selected_account_contact != null) {
        data.contact_id = self.selected_account_contact.contact_id
        data.account_id = self.selected_account_contact.account_id
      } else {
        data.contact_id = self.auditTrialSelectedContact.contact_id
        data.account_id = self.auditTrialSelectedContact.account_id
      }

      if (data.contact_id == null && data.account_id == null) {
        data.contact_id = self.selected_contact_aggrid_node.contact_id
        data.account_id = self.selected_contact_aggrid_node.account_id
      }

      if (self.audit_trial_with_dial.outcome != null) {
        data.action_type_id =
          self.audit_trial_with_dial.outcome.call_action_type_id
        data.outcome_id = self.audit_trial_with_dial.outcome.id
        data.notes = self.audit_trial_with_dial.notes
        data.date_time = self.audit_trial_with_dial.date_time
      } else {
        data.action_type_id = self.audit_trial.action_type.id
        data.outcome_id = self.audit_trial.outcome.id
        data.notes = self.audit_trial.notes
        data.date_time = self.audit_trial.date_time
      }

      // if(self.audit_trial_with_dial.action_type != null){

      //   data.action_type_id = self.audit_trial_with_dial.action_type.id;
      // data.outcome_id = self.audit_trial_with_dial.outcome.id;
      // data.notes = self.audit_trial_with_dial.notes;
      // data.date_time = self.audit_trial_with_dial.date_time;

      // }
      // else{
      //   data.action_type_id = self.audit_trial.action_type.id;
      // data.outcome_id = self.audit_trial.outcome.id;
      // data.notes = self.audit_trial.notes;
      // data.date_time = self.audit_trial.date_time;
      // }

      self.$store
        .dispatch('campaignsManagement/updateSelectedGradeOnSDContact', data)
        .then(res => {
          if (res) {
            let result = res.data
            if (result.data) {
              self.showOpportunityPopUpFromGrade = true
            }
          }
          self.AuditTrialPopupActive = false
          self.AuditTrialWithDialPopupActive = false
          self.showSchedulePopUp = false
          self.showGradePopUp = false
          self.showGradeStepsPopUp = true
        })
        .catch(err => {
          console.error(err)
        })

      if (self.selected_account_contact != null) {
        self.getAccountColumnData(self.selected_account_contact.account_id)
        self.getContactColumnData(self.selected_account_contact.contact_id)
        self.selected_contact_table_id = self.selected_account_contact.table_id
        self.selected_account_table_id = self.selected_account_contact.id
        self.selected_contact_status =
          self.selected_account_contact.contact_status
        self.selected_account_status =
          self.selected_account_contact.account_status
        self.selected_account_id = self.selected_account_contact.account_id
      } else {
        self.getAccountColumnData(self.auditTrialSelectedContact.account_id)
        self.getContactColumnData(self.auditTrialSelectedContact.contact_id)
        self.selected_contact_table_id = self.auditTrialSelectedContact.table_id
        self.selected_account_table_id = self.auditTrialSelectedContact.id
        self.selected_contact_status =
          self.auditTrialSelectedContact.contact_status
        self.selected_account_status =
          self.auditTrialSelectedContact.account_status
        self.selected_account_id = self.auditTrialSelectedContact.account_id
      }

      self.getAllGradeStepsByGradeId(self.grades.grade)
    },
    getAllGradesByCampaignId () {
      let data = {}




      if (this.selectedDialAccountContact != null) {
        data.account_id = this.selectedDialAccountContact.account_id
        data.contact_id = this.selectedDialAccountContact.contact_id
      } else {
        data.contact_id = this.auditTrialSelectedContact.contact_id
        data.account_id = this.auditTrialSelectedContact.account_id
      }


      console.log('datatatata data', data)

      data.campaign_id = this.campaignId

      this.$store
        .dispatch('GradesManagement/getAllGradesByCanBeChangedBySD', data)
        .then(res => {
          this.grade_options = res.data

          // this.grade_options = this.grade_options.filter(ele => ele.grade != '2')
          this.grade_options.sort((a, b) => a.grade - b.grade)

          this.getCampaignGrades(this.campaignId)
        })
        .catch(err => {
          console.error(err)
        })
    },
    dialNext () {
      let self = this
      self.grade_options = []

      self.grades.grade = null
      self.AuditTrialPopupActive = false
      self.AuditTrialWithDialPopupActive = false
      self.showSchedulePopUp = false
      self.showGradePopUp = true
      self.search = ''

      self.getAllGradesByCampaignId()
    },
    addScheduleANextAction () {
      this.submitAuditTrialForm()
      this.showSchedulePopUp = true
    },
    scheduleANextAction () {
      this.addAuditTrialWithDial()
      this.showSchedulePopUp = true
    },
  
    noIdontToScheduleANextAction () {
      this.addAuditTrial()
    },
    closeAuditTrialWithDialPopup (value) {
      if (!value) this.AuditTrialWithDialPopupActive = true
    },
    closeshowSchedulePopup (value) {
      if (!value) this.showSchedulePopUp = true
    },
    closeshowGradePopup (value) {
      if (!value) this.showGradePopUp = true
    },
    closeshowOpportunityExistsPopup (value) {
      if (!value) this.showOpportunityExistsPopup = true
    },
    closeshowTagPopup (value) {
      if (!value) this.showTagAccountContactPopUp = true
    },
    closeshowGradeStepsPopup (value) {
      if (!value) this.showGradeStepsPopUp = true
    },
    closeshowOpportunitiesPopup (value) {
      if (!value) this.showOpportunitiesPopUp = true
    },
    fetchOptionsByActionTypeAndOutcome () {
      let self = this
      let data = {}
      data.action_type_id = this.audittrial_action_type_id
      data.outcome_id = this.audittrial_outcome_id

      this.$store
        .dispatch(
          'AuditTrialsManagement/fetchOptionsByActionTypeAndOutcome',
          data
        )
        .then(res => {
          let result = res.data
          self.optionDescription = result
          self.selected_options = self.optionDescription.option
        })
        .catch(err => {
          console.error(err)
        })
    },
    getDialAction () {
      this.$store
        .dispatch('AuditTrialsManagement/getDialAction')
        .then(res => {
          if (res) {
            this.dialAction = res.data
          }
        })
        .catch(err => {
          console.error(err)
        })
    },
    getAuditTrails (contact_id) {
      let data = {}
      data.campaign_id = this.campaignId
      data.contact_id = contact_id
      this.$store
        .dispatch('AuditTrialsManagement/getAuditTrials', data)
        .then(res => {
          if (res) {
            this.contactsAuditTrials = res.data
            this.contactsAuditTrials.forEach(function (ele) {
              ele.date_time = moment(ele.date_time).format(
                'MM/DD/YYYY hh:mm:ss'
              )
            })
          }
        })
        .catch(err => {
          console.error(err)
        })
    },
    getContactNotes (contact_id) {
      let data = {}
      data.campaign_id = this.campaignId
      data.contact_id = contact_id
      this.$store
        .dispatch('campaignsManagement/getContactNotes', data)
        .then(res => {
          if (res) {
            this.accountNotes = null
            this.contactNotes = JSON.parse(res.data)
          }
        })
        .catch(err => {
          console.error(err)
        })
    },
    getDialCounts (contact_id) {
      let data = {}
      data.campaign_id = this.campaignId
      data.contact_id = contact_id
      this.$store
        .dispatch('campaignsManagement/getDialCounts', data)
        .then(res => {
          if (res) {
            this.dial_counts = res.data
          }
        })
        .catch(err => {
          console.error(err)
        })
    },
    getAccountNotes (account_id) {
      let data = {}
      data.campaign_id = this.campaignId
      data.account_id = account_id
      this.$store
        .dispatch('campaignsManagement/getAccountNotes', data)
        .then(res => {
          if (res) {
            this.contactNotes = null
            this.accountNotes = JSON.parse(res.data)
          }
        })
        .catch(err => {
          console.error(err)
        })
    },
    auditTrialWithDialFunc (data) {
      this.selected_options = []
      this.dialPopupActive = false
      this.AuditTrialPopupActive = false
      this.auditTrialWithDial = true

      this.AuditTrialWithDialPopupActive = true

      // Needs to change
      let action_type_id = this.dialAction.action_type_id
      this.fetchAllOutcomesByActionType(action_type_id)
      this.audit_trial_with_dial.action_type_id = action_type_id
      this.audit_trial_with_dial.account_id =
        this.selectedDialAccountContact.account_id
      this.audit_trial_with_dial.contact_id =
        this.selectedDialAccountContact.contact_id

      this.submitAuditTrialWithDialForm()
    },
    submitAuditTrialWithDialForm () {
      this.addAuditTrialWithDial()
    },
   
    submitAuditTrialForm () {
      this.addAuditTrial()
    },
    refreshAuditTrial () {
      let self = this

      self.audit_trial_with_dial.action_type = null
      self.audit_trial_with_dial.outcome = null
      self.audit_trial_with_dial.action_type_id = null
      self.audit_trial_with_dial.outcome_id = null
      self.audit_trial_with_dial.grade = null
      self.audit_trial_with_dial.campaign_id = null
      self.audit_trial_with_dial.sales_developer_id = null
      self.audit_trial_with_dial.campaign_id = null
      self.audit_trial_with_dial.account_id = null
      self.audit_trial_with_dial.contact_id = null
      self.audit_trial_with_dial.notes = null

      self.audit_trial.action_type = null
      self.audit_trial.outcome = null
      self.audit_trial.action_type_id = null
      self.audit_trial.outcome_id = null
      self.audit_trial.grade = null
      self.audit_trial.campaign_id = null
      self.audit_trial.sales_developer_id = null
      self.audit_trial.campaign_id = null
      self.audit_trial.account_id = null
      self.audit_trial.contact_id = null
      self.audit_trial.notes = null

      self.schedule_a_next_action.subject = null
      self.schedule_a_next_action.notes = null
      self.schedule_a_next_action.selected_account_contact = null


      // self.selectedDialAccountContact = null
      //   self.auditTrialSelectedContact = null
      //   self.selected_account_contact = null
      //   self.selectedEditContactId = null
      //   self.selectedEditAccountId = null

      // if (self.selectedDialAccountContact != null) {
      //   self.selectedDialAccountContact.account_id = null
      //   self.selectedDialAccountContact.contact_id = null
      // }

      // if (self.auditTrialSelectedContact != null) {
      //   self.auditTrialSelectedContact.account_id = null
      //   self.auditTrialSelectedContact.contact_id = null
      // }

      // self.selected_account_contact = null

      // self.selected_account_id = null
      // self.selected_contact_id = null
    },
    addAuditTrial () {
      let self = this
      self.audit_trial.sales_developer_id = self.user_id
      self.audit_trial.campaign_id = self.campaignId
      self.audit_trial.action_type_id = self.audittrial_action_type_id
      self.audit_trial.outcome_id = self.audittrial_outcome_id
      self.audit_trial.grade = self.audittrial_outcome_grade

      if (self.auditTrialSelectedContact == null) {
        self.audit_trial.account_id = self.audit_trial_with_dial.account_id
        self.audit_trial.contact_id = self.audit_trial_with_dial.contact_id
      } else {
        self.audit_trial.account_id = self.auditTrialSelectedContact.account_id
        self.audit_trial.contact_id = self.auditTrialSelectedContact.contact_id
        self.selected_account_contact = self.auditTrialSelectedContact
      }

      // if(self.audit_trial.account_id == null && self.audit_trial.contact_id == null){
      //   self.audit_trial.account_id = this.selected_contact_aggrid_node.data.account_id
      //   self.audit_trial.contact_id = this.selected_contact_aggrid_node.data.contact_id
      // }

      self.$store
        .dispatch('AuditTrialsManagement/addAuditTrials', self.audit_trial)
        .then(function (response) {
          if (response.data.status == 'success') {
            self.$vs.notify({
              color: 'success',
              title: 'Audit Trial Added',
              text: 'The audit trial was added successfully'
            })

            self.audit_trial = {
              date_time: moment(new Date()).format('YYYY-MM-DD hh:mm:ss'),
              outcome: null,
              notes: null,
              action_type: null,
              campaign_id: null,
              sales_developer_id: null,
              account_id: null,
              contact_id: null
            }
            self.AuditTrialPopupActive = false

            if (self.auditTrialSelectedContact == null) {
              self.getAuditTrails(self.audit_trial_with_dial.account_id)
            } else {
              self.getAuditTrails(self.auditTrialSelectedContact.contact_id)
            }

            self.AuditTrialWithDialPopupActive = false

            //  console.log("UPDATED Grade" , response.data.data )
            //  console.log("NODE" , self.selected_contact_aggrid_node)

            self.selected_contact_aggrid_node.data.grade = response.data.data

            self.$refs.SDQCContactFilterGradeChange.gridApi.refreshCells({
              rowNodes: [self.selected_contact_aggrid_node],
              force: true
            })

            self.getDialCounts(
              self.selected_contact_aggrid_node.data.new_contact_id
            )

            self.refreshAuditTrial()

            // self.$router.go(0);
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    fetchAllActionTypes () {
      var self = this
      self.$store
        .dispatch('OutcomesManagement/getAllActionTypesForOutcomes')
        .then(function (response) {
          let response_data = response.data
          self.action_types = response_data
        })
        .catch(err => {
          console.log(err)
        })
    },
    fetchAllOutcomesByActionType (action_type_id) {
      var self = this
      self.$store
        .dispatch(
          'OutcomesManagement/getAllOutcomesByActionype',
          action_type_id
        )
        .then(function (response) {
          let response_data = response.data
          self.outcomes = response_data
        })
        .catch(err => {
          console.log(err)
        })
    },

  
    getSubRole (role_id) {
      this.$store
        .dispatch('contactsManagement/getSubRoles', role_id)
        .then(res => {
          this.sub_roles = res.data
        })
        .catch(err => {
          console.error(err)
        })
    },
    checkOpportunitySelectedCheckboxField (e) {
      let self = this

      this.$nextTick(() => {
        for (const property in self.opportunitiesCheckedFields) {
          if (e.target.id === property) {
            if (self.opportunitiesCheckedFields[property] != null) {
              if (
                self.opportunitiesCheckedFields[property].includes(
                  e.target.value
                )
              ) {
                self.opportunitiesCheckedFields[property] =
                  self.opportunitiesCheckedFields[property].filter(function (
                    ele
                  ) {
                    return ele !== e.target.value
                  })
              } else {
                // alert(e.target.value)
                self.opportunitiesCheckedFields[property].push(e.target.value)
                // console.log(self.opportunitiesCheckedFields[property])

                if (self.opportunitiesCheckedFields[property].length != 0) {
                  self.opportunitiesCheckedFields[property] =
                    self.opportunitiesCheckedFields[property].filter(
                      x => x != null
                    )
                }
              }
            } else {
              self.opportunitiesCheckedFields[property] = []
              self.opportunitiesCheckedFields[property].push(e.target.value)

              if (self.opportunitiesCheckedFields[property].length != 0) {
                self.opportunitiesCheckedFields[property] =
                  self.opportunitiesCheckedFields[property].filter(
                    x => x != null
                  )
              }
            }
          }
        }
        return false
      })
    },
    checkSelectedCheckboxField (e) {

      console.log(e.target.id)
      let self = this

      this.$nextTick(() => {
        for (const property in self.checkedFields) {
          if (e.target.id === property) {
            if (self.checkedFields[property] != null) {
              if (self.checkedFields[property].includes(e.target.value)) {
                self.checkedFields[property] = self.checkedFields[
                  property
                ].filter(function (ele) {
                  return ele !== e.target.value
                })
              } else {
                // alert(e.target.value)
                self.checkedFields[property].push(e.target.value)
                // console.log(self.checkedFields[property])

                if (self.checkedFields[property].length != 0) {
                  self.checkedFields[property] = self.checkedFields[
                    property
                  ].filter(x => x != null)
                }
              }
            } else {
              self.checkedFields[property] = []
              self.checkedFields[property].push(e.target.value)

              if (self.checkedFields[property].length != 0) {
                self.checkedFields[property] = self.checkedFields[
                  property
                ].filter(x => x != null)
              }
            }
          }
        }
        return false
      })


      console.log('checkedFields', self.checkedFields)
    },
    getVerticals (inputValue) {
      return this.$store
        .dispatch('accountsManagement/getVerticals', inputValue)
        .then(response => {
          let data = response.data
          let mappedArray = []
          for (const property in data) {
            mappedArray.push({
              id: data[property].id,
              name: data[property].vertical
            })
          }
          return mappedArray
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    getParentCompany (inputValue) {
      return this.$store
        .dispatch('accountsManagement/searchAutocomplete', inputValue)
        .then(response => {
          let data = JSON.parse(JSON.parse(JSON.stringify(response.data)))
          let mappedArray = []
          for (const property in data) {
            mappedArray.push({
              id: data[property].uuid,
              name: data[property].company_name
            })
          }
          return mappedArray
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    editHeadOfficeCountry () {
      this.showHeadOfficeCountryField = false
      this.showHeadOfficeEditAutocomplete = true
      // console.log(this.$refs.EditHeadOfficeAutoComplete[0].$refs.suggestComponent);
      this.$refs.EditHeadOfficeAutoComplete[0].$refs.suggestComponent.isInFocus = true
      this.$refs.EditHeadOfficeAutoComplete[0].$refs.suggestComponent.isClicking = true
      // this.$refs.EditHeadOfficeAutoComplete.$refs.suggestComponent.input.value = this.accountDescription.head_office_country;
      // this.$refs.EditHeadOfficeAutoComplete.$refs.suggestComponent.value = this.accountDescription.head_office_country;
    },
    editSatelliteOfficeCountry () {
      this.showSatelliteOfficeCountryField = false
      this.showSatelliteOfficeEditAutocomplete = true
      // console.log(this.$refs.EditSatelliteOfficeAutoComplete[0].$refs.suggestComponent);
      this.$refs.EditSatelliteOfficeAutoComplete[0].$refs.suggestComponent.isInFocus = true
      this.$refs.EditSatelliteOfficeAutoComplete[0].$refs.suggestComponent.isClicking = true
      // this.$refs.EditSatelliteOfficeAutoComplete.$refs.suggestComponent.input.value = this.accountDescription.satellite_office_country;
      // this.$refs.EditSatelliteOfficeAutoComplete.$refs.suggestComponent.value = this.accountDescription.satellite_office_country;
    },
    editRegisteredOfficeCountry () {
      this.showRegisteredOfficeCountryField = false
      this.showRegisteredOfficeEditAutocomplete = true
      // console.log(this.$refs.EditRegisteredOfficeAutoComplete[0].$refs.suggestComponent);
      this.$refs.EditRegisteredOfficeAutoComplete[0].$refs.suggestComponent.isInFocus = true
      this.$refs.EditRegisteredOfficeAutoComplete[0].$refs.suggestComponent.isClicking = true
      // this.$refs.EditRegisteredOfficeAutoComplete.$refs.suggestComponent.input.value = this.accountDescription.registered_office_country;
      // this.$refs.EditRegisteredOfficeAutoComplete.$refs.suggestComponent.value = this.accountDescription.registered_office_country;
    },
    editRegistrationJurisdiction () {
      this.showRegistrationJurisdictionField = false
      this.showRegistrationJurisdictionEditAutocomplete = true
      // console.log(this.$refs.EditRegistrationJurisdictionAutoComplete[0].$refs.suggestComponent);
      this.$refs.EditRegistrationJurisdictionAutoComplete[0].$refs.suggestComponent.isInFocus = true
      this.$refs.EditRegistrationJurisdictionAutoComplete[0].$refs.suggestComponent.isClicking = true
      // this.$refs.EditRegistrationJurisdictionAutoComplete.$refs.suggestComponent.input.value = this.accountDescription.registered_office_country;
      // this.$refs.EditRegistrationJurisdictionAutoComplete.$refs.suggestComponent.value = this.accountDescription.registered_office_country;
    },
    editParent () {
      this.showParentField = false
      this.showParentEditAutocomplete = true
      // console.log(this.$refs.EditParentAutoComplete[0].$refs.suggestComponent);
      this.$refs.EditParentAutoComplete[0].$refs.suggestComponent.isInFocus = true
      this.$refs.EditParentAutoComplete[0].$refs.suggestComponent.isClicking = true
      // this.$refs.EditParentAutoComplete.$refs.suggestComponent.input.value = this.accountDescription.registered_office_country;
      // this.$refs.EditParentAutoComplete.$refs.suggestComponent.value = this.accountDescription.registered_office_country;
    },
    editVertical () {
      this.showVerticalField = false
      this.showVerticalEditAutocomplete = true
      // console.log(this.$refs.EditVerticalAutoComplete[0].$refs.suggestComponent);
      this.$refs.EditVerticalAutoComplete[0].$refs.suggestComponent.isInFocus = true
      this.$refs.EditVerticalAutoComplete[0].$refs.suggestComponent.isClicking = true
      // this.$refs.EditVerticalAutoComplete.$refs.suggestComponent.input.value = this.accountDescription.registered_office_country;
      // this.$refs.EditVerticalAutoComplete.$refs.suggestComponent.value = this.accountDescription.registered_office_country;
    },
    isValidJsonString (jsonString) {
      if (
        !(
          jsonString &&
          typeof jsonString === 'string' &&
          typeof jsonString === 'number'
        )
      ) {
        return false
      }

      try {
        JSON.parse(jsonString)
        return true
      } catch (error) {
        return false
      }
    },
    getSeniority () {
      this.$store
        .dispatch('contactsManagement/getSeniority')
        .then(res => {
          this.seniorities = res.data
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    updateSDAccount () {


      let self = this


      let updateData = {}
      updateData.all_field_datas = this.all_field_datas
      // updateData.updated_by_admin = 'yes'
      updateData.campaign_id = this.selectedEditCampaignId
      updateData.account_id = this.selectedEditAccountId
      updateData.sales_developer_id = this.user_id
      updateData.account_status = this.selected_account_status
      updateData.account_table_id = this.selected_account_table_id

    


      self.$vs.loading()


      this.$store
        .dispatch('accountsManagement/updateSDQCAccount', updateData)
        .then(res => {
          this.selectedEditCampaignId = null
          this.selectedEditAccountId = null
        

          let response_data = res.data

          if (response_data.status == 'success') {
            this.$vs.notify({
              color: response_data.status,
              title: response_data.title,
              text: response_data.message
            })

            self.$vs.loading.close()
          }

          this.editSDAccountPopUp = false


          this.selected_account_aggrid_node.data = JSON.parse(response_data.data)


          this.$refs.SDQCAccount.gridApi.refreshCells({
            rowNodes: [this.selected_account_aggrid_node],
            force: true
          })

        })
        .catch(err => {
          console.log(err)
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })


    },
    updateSDContact () {

      console.log('Account_id' , this.selected_account_id)



      let updateData = {}
      updateData.all_contact_field_datas = this.all_contact_field_datas
      updateData.campaign_id = this.selectedEditCampaignId
      updateData.contact_id = this.selectedEditContactId
      updateData.sales_developer_id = this.user_id
      updateData.contact_status = this.selected_contact_status
      updateData.contact_table_id = this.selected_contact_table_id
      // updateData.updated_by_admin = 'yes'
      updateData.account_id = this.selected_account_id

      let self = this

      

      for (const property in this.checkedFields) {
        if (this.checkedFields[property] == '') {
          this.checkedFields[property] = []
        }


        console.log('property' , property)
      }
      

      updateData.checkbox_columns = this.checkedFields

      console.log(updateData)
      // return false
      self.$vs.loading()
      this.$store
        .dispatch('accountsManagement/updateSDQCContact', updateData)
        .then(res => {
          let response_data = res.data





          if (response_data.status == 'success') {
            this.$vs.notify({
              color: response_data.status,
              title: response_data.title,
              text: response_data.message
            })

            self.$vs.loading.close()

          }


          console.log("RESPONSE DATA" , JSON.parse(response_data.data))


          this.selected_contact_aggrid_node.data = JSON.parse(response_data.data)



          this.$refs.SDQCContactFilterGradeChange.gridApi.refreshCells({
            rowNodes: [this.selected_contact_aggrid_node],
            force: true
          })

          if (updateData.contact_id != null) {
            this.getContactNotes(updateData.contact_id)
            this.getDialCounts(updateData.contact_id)
          }

          this.selectedEditCampaignId = null
          this.selectedEditContactId = null

          this.editSDContactPopUp = false
      
        })
        .catch(err => {
          console.error(err)
        })


        self.ddis = []
        self.mobiles = []
        self.social_medias = []
        self.emails = []


    },
    getCountries (inputValue) {
      return this.$store
        .dispatch('accountsManagement/getCountries', inputValue)
        .then(response => {
          let data = response.data
          let mappedArray = []
          for (const property in data) {
            mappedArray.push({
              id: data[property].id,
              name: data[property].name_1
            })
          }
          return mappedArray
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    updateSDAccountForm () {
      this.updateSDAccount()
    },
    updateSDContactForm () {
      this.updateSDContact()
    },
    refreshSDAccount () {
      this.contactsAuditTrials = []
      this.accountNotes = null
      this.dial_counts = 0
   


      this.$refs.SDQCAccount.gridApi.setFilterModel(null)
      this.$refs.SDQCAccount.gridApi.onFilterChanged()
      this.$refs.SDQCContactFilterGradeChange.gridApi.setFilterModel(null)
      this.$refs.SDQCContactFilterGradeChange.gridApi.onFilterChanged()
      this.selected_account_id = null
      this.getAccountDataSource()
      this.getContactDataSource()

      this.contactsAuditTrials = []

    },
    refreshSDContact () {
      this.contactsAuditTrials = []
      this.accountNotes = null
      this.dial_counts = 0
    
      this.$refs.SDQCAccount.gridApi.setFilterModel(null)
      this.$refs.SDQCAccount.gridApi.onFilterChanged()
      this.$refs.SDQCContactFilterGradeChange.gridApi.setFilterModel(null)
      this.$refs.SDQCContactFilterGradeChange.gridApi.onFilterChanged()
      this.selected_account_id = null
      this.getAccountDataSource()
      this.getContactDataSource()

      



    },
    onSDQCAccountFilterModified (event) {
      // this.$refs.SDQCAccount.gridApi.refreshClientSideRowModel()
      // this.getAccountDataSource()
      this.$refs.SDQCContactFilterGradeChange.gridApi.refreshClientSideRowModel()


      console.log('Filter Modified' , event)

      this.getContactDataSource()
    },
    deleteKeys (myObj, array) {
      for (let index = 0; index < array.length; index++) {
        delete myObj[array[index]]
      }
      return myObj
    },
    validateEmailZeroBounce (email) {
      let self = this

      if (email) {
        self.$vs.loading()

        this.$store
          .dispatch('contactsManagement/validateEmailZeroBounce', email)
          .then(res => {
            self.email_validate_status = res.data

            setTimeout(() => self.email_validate_status = null, 3000)

            self.$vs.loading.close()
          })
          .catch(err => {
            console.error(err)
          })
      }
    },
    editSalesDeveloperContact (params) {





this.selected_contact_aggrid_node = params.node

let contact = params.data


let self = this


self.editSDAccountPopUp = false

self.editSDContactPopUp = true
// this.editSelectedAccount = account
let data = {}
data.contact_id = contact.new_contact_id
data.campaign_id = contact.campaign_id
self.selectedEditCampaignId = contact.campaign_id
self.selectedEditContactId = contact.new_contact_id

self.selected_sd_account_id = contact.account_id
self.selected_account_id = contact.account_id

self.selected_contact_status = contact.contact_status
self.selected_contact_table_id = contact.table_id


self.all_contact_field_datas = params.data



Object.keys(self.all_contact_field_datas).forEach(function (key) {




if (typeof self.all_contact_field_datas[key] === 'string' || self.all_contact_field_datas[key] instanceof String) {
  


if (self.all_contact_field_datas[key].startsWith('[') && self.all_contact_field_datas[key] != '[]') {




self.all_contact_field_datas[key] = JSON.parse(self.all_contact_field_datas[key])






}





}


let campaign_data_options = self.all_contact_field_datas['campaign_data_options']

campaign_data_options.forEach(function (ele) {
  if (ele.identifier == 'none_core_field' && ele.type == 'checkbox' && ele.column_id == key) {
   if (self.all_contact_field_datas[key] == null) {
  self.all_contact_field_datas[key] = []
}
  }



  if (ele.identifier == 'none_core_field' && ele.type == 'textarea' && ele.column_id == key  && ele.level == 'contact') {

if(self.all_contact_field_datas[key] == null){
  self.all_contact_field_datas[key] = ''
}


}

})




})













      




  








      





// var array = ["id","acc_id","campaign_id","contact_campaign_id","contact_id","contact_status","contact_id", "contact_status","contact_web"];
// this.editSelectedContact = this.deleteKeys(contact, array);
// console.log("Contact", this.editSelectedContact);
},
    editSalesDeveloperAccount (params) {





      this.selected_account_aggrid_node = params.node

      let account = params.data



      let self = this
      

      self.websites = [
        {
          counter: 0,
          url: null
        }
      ]

      self.showWebsiteExtraField = false

      self.phones = [
        {
          counter: 0,
          phone_no: null
        }
      ]

      self.showPhoneExtraField = false

      self.linkedins = [
        {
          counter: 0,
          url: null
        }
      ]

      self.showLinkedExtraField = false
      self.editSDContactPopUp = false
      self.editSDAccountPopUp = true
      // this.editSelectedAccount = account
      let data = {}
      data.account_id = account.acc_id
      data.campaign_id = account.account_campaign_id
      self.selectedEditCampaignId = account.account_campaign_id
      self.selectedEditAccountId = account.acc_id
      self.selected_account_status = account.account_status
      self.selected_account_table_id = account.table_id

      self.all_field_datas = params.data





      Object.keys(self.all_field_datas).forEach(function (key) {


        if (typeof self.all_field_datas[key] === 'string' || self.all_field_datas[key] instanceof String) {




if (self.all_field_datas[key].startsWith('[') && self.all_field_datas[key] != '[]') {


  

  self.all_field_datas[key] = JSON.parse(self.all_field_datas[key])






}





}


let campaign_data_options = self.all_field_datas['campaign_data_options']

campaign_data_options.forEach(function (ele) {
  if (ele.identifier == 'none_core_field' && ele.type == 'checkbox' && ele.column_id == key) {
   if (self.all_field_datas[key] == null) {
  self.all_field_datas[key] = []
}







  }


  if (ele.identifier == 'none_core_field' && ele.type == 'textarea' && ele.column_id == key  && ele.level == 'account') {

if(self.all_field_datas[key] == null){
  self.all_field_datas[key] = ''
}


}





})



      })
        
      

      





           




                  




              

             



            



                  




  


    
    },
    showSalesDeveloperAuditTrial (params) {
      this.selected_contact_aggrid_node = params.node

      let contact = params.data


      let self = this

      self.AuditTrialPopupActive = true

      self.auditTrialSelectedContact = contact

      self.auditTrialWithDial = false

      self.showContactsFieldsWithContactID(contact.new_contact_id, contact.account_id)

      // this.editSelectedAccount = account
    },

    showContactsWithAccountID (account_id) {


      this.contactsAuditTrials = []
      this.accountNotes = null
      this.dial_counts = 0


      if (account_id == null) {
        this.$refs.SDQCAccount.gridApi.clearFocusedCell()
      }

      let selected = this.$refs.SDQCContactFilterGradeChange.gridApi.getSelectedNodes()
      _.each(selected, function (node) {
        node.hightlight = null
        node.setSelected(false)
      })

      // this.getAccountNotes(account_id)

      this.selected_account_id = account_id


      this.$refs.SDQCContactFilterGradeChange.gridApi.showLoadingOverlay();

      
      this.getContactDataSource()
      this.selected_contact_id = null
    },
    showContactsFieldsWithContactID (contact_id,account_id) {
      let self = this


      self.selected_contact_id = contact_id
    
      if (contact_id == null) {

        self.$refs.SDQCContactFilterGradeChange.gridApi.clearFocusedCell()


        let selected = self.$refs.SDQCAccount.gridApi.getSelectedNodes()
        _.each(selected, function (node) {
          node.highlighted = '0'
          node.setSelected(false)
        })

        self.contactsAuditTrials = []
        self.accountNotes = null
        self.dial_counts = 0
      } else {


        self.$refs.SDQCAccount.gridApi.forEachNode(function(node) { 
          let node_data = node.data

       


          if(node_data.acc_id == account_id){

          
            node.setSelected(true)
            node.hightlight = '1'
          }
    });



          var focusedCell = self.$refs.SDQCAccount.gridApi.getSelectedNodes()
          let selected_row_index = focusedCell[0].rowIndex

          let page_index = Math.floor(selected_row_index / self.$refs.SDQCAccount.gridApi.paginationGetPageSize())

          self.$refs.SDQCAccount.gridApi.paginationGoToPage(page_index)

        self.getAuditTrails(contact_id)
        self.getContactNotes(contact_id)
        self.getDialCounts(contact_id)

        let selected = self.$refs.SDQCAccount.gridApi.getSelectedNodes()
        _.each(selected, function (node) {
          node.highlighted = '1'
          node.setSelected(true)
        })




    self.selected_account_id = account_id


      }
    },

    addFields () {
      this.$router.push({ path: `/fields/campaign-field/add` })
    },
    onPaginationChangeContact(data){
// ddddd

//       let self = this

//       if (data.keepRenderedRows == true){

//         let displayed_contact_nodes =   self.$refs.SDQCContactFilterGradeChange.gridApi.getRenderedNodes().map((row) => row.data.account_id);

// console.log(displayed_contact_nodes.every( (val, i, arr) => val === arr[0] ))

// if(displayed_contact_nodes.every( (val, i, arr) => val === arr[0] ) == true){
//   console.log("All Same")
// }else{
//   console.log("All Not Same")

// self.selected_account_id = null

// let selected = self.$refs.SDQCAccount.gridApi.getSelectedNodes()
// _.each(selected, function (node) {
// node.highlighted = '0'
// node.setSelected(false)
// })
// self.$refs.SDQCContactFilterGradeChange.gridApi.clearFocusedCell()





// }





// console.log(displayed_contact_nodes)

//       }

   


     






    },
    getAccountDataSource() {
      var self = this;
      let data = {};
      data.campaign_id = self.$route.params.campaignId
      data.filter_start_date_time = self.filter.start_date  
      data.filter_end_date_time = self.filter.end_date
      self.$store
        .dispatch("accountsManagement/fetchAllSDQCAccountsForClientSideFilterGradeChanged", data)
        .then(function(response) {
          let response_data = JSON.parse(response.data);


          response_data.forEach(function (ele) {

        if (ele._c68046a9_7aaf_4876_9c49_936c28d479af) {
        if (ele._c68046a9_7aaf_4876_9c49_936c28d479af.length == 0) {
          ele._c68046a9_7aaf_4876_9c49_936c28d479af = ''
        } else if (ele._c68046a9_7aaf_4876_9c49_936c28d479af.length > 1) {
          ele._c68046a9_7aaf_4876_9c49_936c28d479af = 'ΞΞ'
        } else {
          ele._c68046a9_7aaf_4876_9c49_936c28d479af = ele._c68046a9_7aaf_4876_9c49_936c28d479af[0].url
        }
      }


      if (ele._c2c0a5f8_e0aa_4ea9_b0e9_92195a9245a0) {
        if (ele._c2c0a5f8_e0aa_4ea9_b0e9_92195a9245a0.length == 0) {
          ele._c2c0a5f8_e0aa_4ea9_b0e9_92195a9245a0 = ''
        } else if (ele._c2c0a5f8_e0aa_4ea9_b0e9_92195a9245a0.length > 1) {
          ele._c2c0a5f8_e0aa_4ea9_b0e9_92195a9245a0 = 'ΞΞ'
        } else {
          ele._c2c0a5f8_e0aa_4ea9_b0e9_92195a9245a0 = ele._c2c0a5f8_e0aa_4ea9_b0e9_92195a9245a0[0].url
        }
      }









    })




          

          




         

          self.accountRecords = response_data;

        })
        .catch(err => {
          console.error(err);
        });
    },

    getContactDataSource() {
      var self = this;
      let data = {};
      data.campaign_id = self.$route.params.campaignId
      data.filter_start_date_time = self.filter.start_date  
      data.filter_end_date_time = self.filter.end_date
      data.account_id = self.selected_account_id




      self.$store
        .dispatch("accountsManagement/fetchAllSDQCContactsForClientSideFilterGradeChanged", data)
        .then(function(response) {



          


          let response_data = JSON.parse(response.data);



          response_data.forEach(function (ele) {

            if (ele._2619e88b_cc7c_48bd_8934_de7113d6b849) {

                      let all_social_medias = ele._2619e88b_cc7c_48bd_8934_de7113d6b849

                    if (ele._2619e88b_cc7c_48bd_8934_de7113d6b849.length == 0) {
                      ele._2619e88b_cc7c_48bd_8934_de7113d6b849 = ''
                    } else if (ele._2619e88b_cc7c_48bd_8934_de7113d6b849.length > 1) {
                      ele._2619e88b_cc7c_48bd_8934_de7113d6b849 = 'ΞΞ'
                      ele._053ef7ea_b2ed_4110_8318_76d7e8268526 = all_social_medias[0].summary;

                    } else {
                      ele._2619e88b_cc7c_48bd_8934_de7113d6b849 = ele._2619e88b_cc7c_48bd_8934_de7113d6b849[0].social_media
                        ele._053ef7ea_b2ed_4110_8318_76d7e8268526 = all_social_medias[0].summary;

                    }
                  }


                  if (ele._0c483105_8807_4d68_8299_91f449e7085a) {
                    if (ele._0c483105_8807_4d68_8299_91f449e7085a.length == 0) {
                      ele._0c483105_8807_4d68_8299_91f449e7085a = ''
                    } else if (ele._0c483105_8807_4d68_8299_91f449e7085a.length > 1) {
                      ele._0c483105_8807_4d68_8299_91f449e7085a = 'ΞΞ'
                    } else {
                      ele._0c483105_8807_4d68_8299_91f449e7085a = ele._0c483105_8807_4d68_8299_91f449e7085a[0].ddi
                    }
                  }

                  if (ele._f045b88c_3b21_4a30_9576_f566641e3447) {
                    if (ele._f045b88c_3b21_4a30_9576_f566641e3447.length == 0) {
                      ele._f045b88c_3b21_4a30_9576_f566641e3447 = ''
                    } else if (ele._f045b88c_3b21_4a30_9576_f566641e3447.length > 1) {
                      ele._f045b88c_3b21_4a30_9576_f566641e3447 = 'ΞΞ'
                    } else {
                      ele._f045b88c_3b21_4a30_9576_f566641e3447 = ele._f045b88c_3b21_4a30_9576_f566641e3447[0].mobile
                    }
                  }

                  if (ele._7f678dc8_5d41_4ca3_aaad_deedfb594a6d) {
                    if (ele._7f678dc8_5d41_4ca3_aaad_deedfb594a6d.length == 0) {
                      ele._7f678dc8_5d41_4ca3_aaad_deedfb594a6d = ''
                    } else if (ele._7f678dc8_5d41_4ca3_aaad_deedfb594a6d.length > 1) {
                      ele._7f678dc8_5d41_4ca3_aaad_deedfb594a6d = 'ΞΞ'
                    } else {
                      ele._7f678dc8_5d41_4ca3_aaad_deedfb594a6d = ele._7f678dc8_5d41_4ca3_aaad_deedfb594a6d[0].email
                    }
                  }

                  // if(ele._62939d40_a238_4b67_8d82_eaa60e24e248){
                  //   ele._62939d40_a238_4b67_8d82_eaa60e24e248 = moment(ele._62939d40_a238_4b67_8d82_eaa60e24e248).format('DD/MM/YYYY')
                  // }


         




                })
  
        

          




         
                self.$refs.SDQCContactFilterGradeChange.gridApi.hideOverlay()

          self.contactRecords = response_data;


          console.log("CONTACT RECORDS" , self.contactRecords)




        })
        .catch(err => {
          console.error(err);
        });
    },


//     getContactDataSource () {
//       var self = this
//       this.contactDataSource = {
//         getRows (params) {
//           if (self.selected_filter_contact_tag.length != 0) {
//             params.request.selected_filter_contact_tag =
//               self.selected_filter_contact_tag
//           }

//           self.contactParamsRequest = params.request
//           params.request.campaignId = self.$route.params.campaignId
//           params.request.userId = self.sales_developer_id
//           params.request.campaignName = atob(self.$route.params.campaignName)
//           params.request.selected_account_id = self.selected_account_id
//           params.request.all_sales_developer = 'Yes'
//           params.request.filter_start_date_time = self.filter.start_date
//           params.request.filter_end_date_time = self.filter.end_date


//           console.log("before" , params.request.filter_start_date_time)
//           console.log("after" , params.request.filter_end_date_time)



//           self.$store
//             .dispatch('accountsManagement/fetchAllSDQCContactsForChangeGradeFilter', params.request)
//             .then(function (response) {
//               let response_data = response.rows



//               response_data.forEach(function (ele) {


// if(ele._2619e88b_cc7c_48bd_8934_de7113d6b849){

//   if (ele._2619e88b_cc7c_48bd_8934_de7113d6b849.length == 0) {
//   ele._93c2f968_0426_4a60_957f_423b74c22712 = "";

// } else if (ele._2619e88b_cc7c_48bd_8934_de7113d6b849.length > 1) {
//   ele._93c2f968_0426_4a60_957f_423b74c22712 = "ΞΞ";

// } else {
//   ele._93c2f968_0426_4a60_957f_423b74c22712 = ele._2619e88b_cc7c_48bd_8934_de7113d6b849[0].summary;

// }
// }



// });

 

//                 if (response_data) {
//                   if (response_data.length > 0) {
//                     self.$refs.SDQCContactFilterGradeChange.gridApi.hideOverlay()
//                     params.success({ rowData: response.rows , rowCount: response.lastRow })
//                   } else {
//                     self.$refs.SDQCContactFilterGradeChange.gridApi.showNoRowsOverlay()
//                     params.success({ rowData: [] , rowCount: response.lastRow})
//                   }
//                 } else {
//                   params.fail()
//                 }
//             })
//             .catch(err => {
//               console.error(err)
//             })

//         }
//       }
//     },
    removeSelectedNewMobile (mobile) {
      this.mobiles = this.mobiles.filter(item => {
        return item.counter != mobile.counter
      })
    },
    removeSelectedMobile (mobile) {
      this.core_field_datas.mobile = this.core_field_datas.mobile.filter(
        item => {
          return item.mobile != mobile
        }
      )
    },
    addMobile () {
      if (this.mobiles.length == 1 && !this.showMobileExtraField) {
        this.showMobileExtraField = true
      } else if (this.mobiles.length == 1 && this.showMobileExtraField) {
        this.mobiles.push({
          mobile: null,
          is_primary: null,
          mobile_phone_code: null,
          counter: ++this.mobile_counter
        })
      } else {
        this.mobiles.push({
          mobile: null,
          is_primary: null,
          mobile_phone_code: null,
          counter: ++this.mobile_counter
        })
      }
    },
    removeSelectedNewSocial_media (social_media) {
      this.social_medias = this.social_medias.filter(item => {
        return item.counter != social_media.counter
      })
    },
    removeSelectedSocial_media (social_media) {
      this.core_field_datas.social_media =
        this.core_field_datas.social_media.filter(item => {
          return item.social_media != social_media
        })
    },
    addSocial_media () {
      if (this.social_medias.length == 1 && !this.showSocial_mediaExtraField) {
        this.showSocial_mediaExtraField = true
      } else if (
        this.social_medias.length == 1 &&
        this.showSocial_mediaExtraField
      ) {
        this.social_medias.push({
          url: null,
          summary: null,
          is_primary: null,
          counter: ++this.social_media_counter
        })
      } else {
        this.social_medias.push({
          url: null,
          summary: null,
          is_primary: null,
          counter: ++this.social_media_counter
        })
      }
    },
    getCampaignDescription () {
      let self = this
      self.$store
        .dispatch(
          'campaignsManagement/fetchCampaign',
          self.$route.params.campaignId
        )
        .then(res => {
          self.campaignDescription = res.data
        })
        .catch(err => {
          console.log(err)
        })
    },
    getSDAccountColumns () {
      let self = this
      self.$store
        .dispatch(
          'campaignsManagement/getAllAccountSelectedCampaignColumns',
          self.$route.params.campaignId
        )
        .then(res => {

          let selected_columns = JSON.parse(res.data);



  selected_columns = selected_columns.filter(function(ele) {
    return ele.identifier != 'phone_code' && ele.identifier != 'phone_type' && ele.identifier != 'account_status' && ele.identifier != 'account_sub_status' && ele.identifier != 'account_status_notes'
  });


  var index = 1;
selected_columns.forEach(function(ele) {
  ele.id = ele.uuid

  ele.headerName = ele.name;

  ele.field = '_' + ele.id.replaceAll("-", "_");

  if (ele.type == "textarea") {
                ele.cellRenderer =  function(params) {
                            return params.value ? params.value : '';
                        }
              }


                if (ele.type == "date" || ele.type == "datetime") {
      ele.filter = "agDateColumnFilter";
     

ele.filterParams = filterDateParams
    } else if (ele.type == "number") {
      ele.filter = "agNumberColumnFilter";
      ele.filterParams = {
    buttons: ["apply", "reset"],
    maxNumConditions: 4
  };
    } else {
      ele.filter = "agTextColumnFilter";
      ele.filterParams = {
    buttons: ["apply", "reset"],
    maxNumConditions: 4
  };
    }





  ele.width = 170;

});

this.accountColumnDefs = selected_columns


      

          let account_status = {
            column_name: "account_status",
            field: "account_status",
            filter: "agTextColumnFilter",
            filterParams: {
              buttons: ["apply", "reset"],
              maxNumConditions: 4
            },
            headerName: "Account Status"
          };

          this.accountColumnDefs.push(account_status);


          let account_status_notes = {
            column_name: "account_status_notes",
            field: "account_status_notes",
            filter: "agTextColumnFilter",
            filterParams: {
              buttons: ["apply", "reset"],
              maxNumConditions: 4
            },
            headerName: "Account Status Notes"
          };

          this.accountColumnDefs.push(account_status_notes);

        
        

    
        })
        .catch(err => {
          console.log(err)
        })
    },
    getSDContactsColumns () {
      let self = this
      self.$store
        .dispatch(
          'campaignsManagement/getAllContactSelectedCampaignColumns',
          self.$route.params.campaignId
        )
        .then(res => {

          let contact_columns = JSON.parse(res.data);


          
          


          contact_columns = contact_columns.filter(function(ele) {
              return ele.identifier != 'mobile_phone_code' && ele.identifier != 'ddi_phone_code' && ele.identifier != 'contact_status' && ele.identifier != 'contact_sub_status' && ele.identifier != 'contact_status_notes' && ele.identifier != 'grade'
            });


            



            var index = 1;
            contact_columns.forEach(function(ele) {

              


              ele.id = ele.uuid

          

          
              ele.headerName = ele.name;


              ele.field = '_' + ele.id.replaceAll("-", "_");


              if (ele.type == "textarea") {
                ele.cellRenderer =  function(params) {
                            return params.value ? params.value : '';
                        }
              }




                if (ele.type == "date" || ele.type == "datetime") {
                  ele.filter = "agDateColumnFilter";

                  ele.filterParams = filterDateParams
                 

                } else if (ele.type == "number") {
                  ele.filter = "agNumberColumnFilter";
                  ele.filterParams = {
                buttons: ["apply", "reset"],
                maxNumConditions: 4
              };
                } else {
                  ele.filter = "agTextColumnFilter";
                  ele.filterParams = {
                buttons: ["apply", "reset"],
                maxNumConditions: 4
              };
                }


              ele.width = 170;
              
            });

     
    


          contact_columns.push({
            headerName: 'Grade',
            field: 'grade',
            width: 100,
            filter : 'agNumberColumnFilter',
            filterParams : {
                buttons: ["apply", "reset"],
                maxNumConditions: 4
              }
           
          })

     

          var sorted = contact_columns

       
          

          this.contactsColumnDefs = sorted


          let sales_developer = {
            column_name: "sales_developer",
            field: "sales_developer",
            filter: "agTextColumnFilter",
            filterParams: {
              buttons: ["apply", "reset"],
              maxNumConditions: 4
            },
            headerName: "Sales Developer"
          };

          this.contactsColumnDefs.push(sales_developer);


          let date_time = {
            column_name: "audit_trial_created_at",
            field: "audit_trial_created_at",
            filter: "agDateColumnFilter",
            filterParams : filterDateParams,
            headerName: "Date Time",
            cellRenderer: function (params) {
              return moment(params.value).format('YYYY-MM-DD HH:mm:ss')
            }
          };

          this.contactsColumnDefs.push(date_time);


          let company_name = {
            column_name: "_ec41e532_632d_4323_8071_f60b4543a68a",
            field: "_ec41e532_632d_4323_8071_f60b4543a68a",
            filter: "agTextColumnFilter",
            filterParams: {
              buttons: ["apply", "reset"],
              maxNumConditions: 4
            },
            headerName: "Company Name"
          };

          this.contactsColumnDefs.push(company_name);


          let contact_status = {
            column_name: "contact_status",
            field: "contact_status",
            filter: "agTextColumnFilter",
            filterParams: {
              buttons: ["apply", "reset"],
              maxNumConditions: 4
            },
            headerName: "Contact Status"
          };

          this.contactsColumnDefs.push(contact_status);


          let contact_status_notes = {
            column_name: "contact_status_notes",
            field: "contact_status_notes",
            filter: "agTextColumnFilter",
            filterParams: {
              buttons: ["apply", "reset"],
              maxNumConditions: 4
            },
            headerName: "Contact Status Notes"
          };

          this.contactsColumnDefs.push(contact_status_notes);







        })
        .catch(err => {
          console.log(err)
        })
    },

   
    getPhoneCodes (inputValue) {
      return this.$store
        .dispatch('accountsManagement/getPhoneCodes', inputValue)
        .then(response => {
          let data = response.data
          let mappedArray = []
          for (const property in data) {
            if (data[property].phone_code) {
              mappedArray.push({
                id: data[property].id,
                name: data[property].phone_code + ' - ' + data[property].name_1
              })
            }
          }
          return mappedArray
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    getAllPhoneCodes () {
      let self = this
      this.$store
        .dispatch('accountsManagement/getAllPhoneCodes')
        .then(response => {
          self.all_phone_codes = response.data
          self.all_countries = response.data
          self.all_phone_codes.forEach(function(ele){
            if(ele.phone_code){
              ele.name_with_code = ele.phone_code + ' - ' + ele.name_1
            }
            return ele
          })
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },


    addMobile (key) {

let self = this

Object.keys(self.all_contact_field_datas).forEach(function (k) {

  if (k == key){

    if (self.all_contact_field_datas[k] == null){
      self.all_contact_field_datas[k] = []
    }
    
    self.all_contact_field_datas[k].push({mobile_phone_code : null , mobile : null})

  }



})


},
    removeSelectedMobile (key,web) {
      let self = this

      Object.keys(self.all_contact_field_datas).forEach(function (k) {

        if (k == key){
          

          self.all_contact_field_datas[k] = self.all_contact_field_datas[k].filter(item => {

        return item != web
      })

        }



})
    },
    addDDI (key) {

let self = this

Object.keys(self.all_contact_field_datas).forEach(function (k) {

  if (k == key){

    if (self.all_contact_field_datas[k] == null){
      self.all_contact_field_datas[k] = []
    }
    
    self.all_contact_field_datas[k].push({ddi_phone_code : null , ddi : null , is_primary : false})

  }



})


},
    removeSelectedDDI (key,web) {
      let self = this

      Object.keys(self.all_contact_field_datas).forEach(function (k) {

        if (k == key){
          

          self.all_contact_field_datas[k] = self.all_contact_field_datas[k].filter(item => {

        return item != web
      })

        }



})
    },



    addPhone (key) {





let self = this

Object.keys(self.all_field_datas).forEach(function (k) {

  if (k == key){

    if (self.all_field_datas[k] == null){
      self.all_field_datas[k] = []
    }
    
    self.all_field_datas[k].push({phone_code : null , phone_no : null , phone_type : null})

  }



})


},
    removeSelectedPhone (key,web) {
      let self = this

      Object.keys(self.all_field_datas).forEach(function (k) {

        if (k == key){
          

          self.all_field_datas[k] = self.all_field_datas[k].filter(item => {

        return item != web
      })

        }



})
    },
    removeSelectedWeb (key,web) {
      let self = this

      Object.keys(self.all_field_datas).forEach(function (k) {

        if (k == key){
          

          self.all_field_datas[k] = self.all_field_datas[k].filter(item => {

        return item != web
      })

        }



})
    },

    addWebsite (key) {





      let self = this

      Object.keys(self.all_field_datas).forEach(function (k) {

        if (k == key){

          if (self.all_field_datas[k] == null){
            self.all_field_datas[k] = []
          }
          
          self.all_field_datas[k].push({url : null})

        }



})


    },
    removeSelectedSocialMedia (key,social_media) {
  let self = this

  Object.keys(self.all_contact_field_datas).forEach(function (k) {

    if (k == key){
      

      self.all_contact_field_datas[k] = self.all_contact_field_datas[k].filter(item => {

    return item != social_media
  })

    }



})
},

addSocialMedia (key) {





  let self = this

  Object.keys(self.all_contact_field_datas).forEach(function (k) {

    if (k == key){

      if (self.all_contact_field_datas[k] == null){
        self.all_contact_field_datas[k] = []
      }


      
      self.all_contact_field_datas[k].push({social_media : null,summary : null})

    }



})


},
    removeSelectedEmail (key,email) {
  let self = this

  Object.keys(self.all_contact_field_datas).forEach(function (k) {

    if (k == key){
      

      self.all_contact_field_datas[k] = self.all_contact_field_datas[k].filter(item => {

    return item != email
  })

    }



})
},

addEmail (key) {





  let self = this

  Object.keys(self.all_contact_field_datas).forEach(function (k) {

    if (k == key){

      if (self.all_contact_field_datas[k] == null){
        self.all_contact_field_datas[k] = []
      }


      
      self.all_contact_field_datas[k].push({email : null})

    }



})


},
    removeSelectedLinkedin (key,linkedin) {
  let self = this

  Object.keys(self.all_field_datas).forEach(function (k) {

    if (k == key){
      

      self.all_field_datas[k] = self.all_field_datas[k].filter(item => {

    return item != linkedin
  })

    }



})
},

addLinkedIn (key) {





let self = this

Object.keys(self.all_field_datas).forEach(function (k) {

  if (k == key){

    if (self.all_field_datas[k] == null){
      self.all_field_datas[k] = []
    }
    
    self.all_field_datas[k].push({url : null})

  }



})


},
    removeSelectedNewDdi (ddi) {
      this.ddis = this.ddis.filter(item => {
        return item.counter != ddi.counter
      })
    },
    removeSelectedDdi (ddi) {
      this.core_field_datas.ddi = this.core_field_datas.ddi.filter(item => {
        return item.ddi != ddi
      })
    },
  

    goBack: function () {
      this.$router.go(-1)
    },
    getRoles () {
      this.$store
        .dispatch('contactsManagement/getRoles')
        .then(res => {
          this.roles = res.data
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    fetchCampaignDetails () {
      this.$store
        .dispatch('campaignsManagement/fetchCampaign', this.campaignId)
        .then(res => {
          this.selected_campaign = res.data
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.selected_campaign = true
            return
          }
          console.error(err)
        })
    },
    getPhoneTypes () {
      this.$store
        .dispatch('accountsManagement/getPhoneTypes')
        .then(res => {
          this.phoneTypes = res.data
          this.phoneTypes = this.phoneTypes.filter(
            item =>
              item.slug != 'head_office_switchboard' &&
              item.slug != 'site_switchboard'
          )
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },

  },
  beforeMount () {
    if (this.authorized) {
      this.getSDCampaignViewSettings()
      this.getSDAccountColumns()
      this.getSDContactsColumns()
      this.getAccountDataSource()
      this.getContactDataSource()

      // this.getSDViewLists()
    }
  },
  mounted () {
    if (this.authorized) {
     
      this.getCampaignDescription()
    }
  },
  created () {
    var self = this
    defineAbilitiesFor().then(function (data) {
      self.abilities = data
    })
    self.sales_developer_id = self.$route.params.sd_user_id
    let userInfo = JSON.parse(localStorage.getItem('userInfo'))
    this.user_id = userInfo['uid']
    // this.viewing_as_full_name = atob(self.$route.params.sd_user_full_name)

    if (!moduleAccountsManagement.isRegistered) {
      defineAbilitiesFor().then(function (data) {
        self.abilities = data
      })
      this.$store.registerModule('accountsManagement', moduleAccountsManagement)
      moduleAccountsManagement.isRegistered = true
    }

    if (!moduleCampaignsManagement.isRegistered) {
      this.$store.registerModule(
        'campaignsManagement',
        moduleCampaignsManagement
      )
      moduleCampaignsManagement.isRegistered = true
    }

  

    if (!moduleAuditTrialManagement.isRegistered) {
      this.$store.registerModule(
        'AuditTrialsManagement',
        moduleAuditTrialManagement
      )
      moduleAuditTrialManagement.isRegistered = true
    }



    this.campaignId = this.$route.params.campaignId

  }
}
</script>
<!-- <style src='vue-dialog-drag/dist/vue-dialog-drag.css'></style> -->
<style scoped>
.audit_trial_style {
  height: 600px;
  overflow-y: scroll;
}

.vs-input-class{
  width: 100%;
  border: 1px solid rgba(0, 0, 0, 0.2);
  font-size: 1rem;
  height: 38px;
  padding-left: 10px;
  padding-right: -10px;
  border-radius: 4px;
  background: transparent;
  transition: all .2s ease;


}

.removeButton {
  cursor: pointer;
}

.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.searchbox {
  margin-left: 5px;
  width: 600px;
}

.phone_code {
  margin-left: 5px;
  width: 220px;
}

.filter {
  width: 300px;
}

.pointer {
  cursor: pointer;
}

.item.expanded {
  background-color: white !important;
  color: black !important;
}

.pointer {
  cursor: pointer;
}

.address_th {
  padding: 30px;
}

.address_td {
  padding: 30px;
  font-weight: 200;
}

.agrid-scroll {
  overflow-x: hidden;
  overflow-y: scroll;
  height: 572px;
  padding-right: 15px;
}

.td .vs-table--td {
  width: 100%;
}

.ql-class {
  width: 580px;
}

.vertical-align {
  font-size: 10px;
  display: flex;
  justify-content: center;
  /* align horizontal */
  align-items: center;
  /* align vertical */
  /* width: 800px; */
}

.tag-filter {
  cursor: pointer;
}

.blur-content {
  width: 100%;
  height: 100%;
  background: rgba(247, 244, 244, 0.7);
  top: 0;
  left: 0;
  z-index: 2;
  pointer-events: none;
  opacity: 0.5;
}

.text_box {
  display: none;
}

/* .autocom {
  padding: 0.7rem !important;
  border: 1px solid rgba(0, 0, 0, 0.2);
  font-size: 1rem !important;
  width: 80%;

} */

/* .auto_search_container {
  justify-content: center;
  align-items: center;
  width: 200px;
  margin-top: 100px;
  position: relative;
  input {
    width: 100%;
    border: none;
    height: 38px;
    padding-left: 10px;
    padding-right: -10px;
    box-shadow: inset 0 0 0 1px #b2b2b2;
    border-radius: 4px;
    background: transparent;
    transition: all .2s ease;
    &:focus {
      outline: none;
      box-shadow: inset 0 0 0 2px #ffb300;
    }
  }
  .results {
    position: absolute;
    width: 100%;
    background: #fff;  box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);
    .result {
      padding:  20px 0.75rem;
      &:hover {
        background: #efefef;
      }
    }
  }
} */
</style>
